<template>
  <div class="attachments">
    <h5>{{ title }}</h5>
    <ul class="files">
      <li class="file" v-for="(attachement, id) in files" :key="id">
        <a class="download" :href="attachement.file.path[$i18n.locale]" target="_blank" download>
          <div class="title">
            <p>{{ attachement.file.format }} - {{ attachement.file.size }}</p>
            <p class="tx-wg-bold">{{ attachement.label[$i18n.locale] }}</p>
          </div>
          <div class="icon">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15 15.82a1.5 1.5 0 01-1.5 1.5H3.64a1.5 1.5 0 01-1.5-1.5V6.18a1.5 1.5 0 011.5-1.5h8.53v-1H3.64a2.5 2.5 0 00-2.5 2.5v9.64a2.5 2.5 0 002.5 2.5h9.85a2.5 2.5 0 002.5-2.5v-4.68H15z" fill="#e95263"/><path d="M20.05 2.18h-6a.31.31 0 00-.22.53L16.11 5l-7.38 7.36 1.42 1.41 7.37-7.37 2.31 2.32a.31.31 0 00.53-.22v-6a.31.31 0 00-.31-.32z" fill="#e95263"/></svg>
            <p>{{ $t('download-file') }}</p>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Attachments',
  props: {
    title: {
      type: String,
      required: true
    },
    files: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.attachments {
  color: $col-navy-dark;
  margin-top: $padding/2;
  h5 {
    margin-bottom: $padding/6;
  }
  .files {
    list-style-type: none;
    &:hover {
      cursor: pointer;
    }
    li {
      color: $col-red-light;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: $padding/6;
      @media screen and (max-width: $mq-mobile) {
        margin-bottom: $padding/6;
      }
      .download {
        width: 100%;
        color: $col-navy-dark;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        &:hover {
          text-decoration: none;
          cursor: pointer;
        }
        .title {
          display: flex;
          flex-direction: column;
          p:first-child {
            font-size: 0.8rem;
            line-height: 140%;
          }
          p:last-child {
            color: $col-red-light;
          }
        }
        .icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          @media screen and (max-width: $mq-mobile) {
            svg {
              transform: scale(0.8, 0.8);
            }
          }
          p {
            color: $col-red-light;
            margin-top: 0.3rem;
            font-size: 0.8rem;
            @media screen and (max-width: $mq-mobile) {
              font-size: 0.7rem;
            }
          }
        }
      }
    }
  }
}
</style>
